<template>
  <div>
    <van-skeleton title avatar :row="8" :loading="loading" style="margin-top:1.1rem">
      <div class="forward-templateall">

        <div class="articlebox" @click="gotocircledetails(dynamiclistdata.id,dylistindex)">

          <div class="articleright">
            <div class="article-r-top">
              <div class="cleardynamic" @click.stop="showPopup">
                <span class="cuIcon-more">
                  <van-icon name="ellipsis" />
                </span>
              </div>

              <div class="article-title">
                <div class="articletx" @click.stop="gotootherdynamic(dynamiclistdata.api_uid)">
                  <img v-if="dynamiclistdata.avatar_url" :src="dynamiclistdata.avatar_url" />
                  <img v-else :src="avatar_url" />
                </div>
                <div>
                  <div class="article-author" @click.stop="gotootherdynamic(dynamiclistdata.api_uid)">{{dynamiclistdata.name}}</div>
                  <div class="article-time">{{dynamiclistdata.ctime}}</div>
                </div>
              </div>
            </div>

            <div class="blockname" v-if="dynamiclistdata.pid==0">
              <div class="article-content" v-if="dynamiclistdata.content">
                <pre :class="dynamiclist.is_exceed % 2 == 0 ? 'bigheight':'article-content-text' " ref="circlecontent">{{dynamiclistdata.content}}</pre>
                <div class="article-content-btn" v-if="dynamiclistdata.is_exceed!=0" @click.stop="openbtn(dylistindex)">
                  <p v-if="dynamiclist.is_exceed % 2 == 1">展开</p>
                  <p v-else>收起</p>
                </div>

              </div>

              <div class="article-imagebox" v-if="dynamiclistdata.thumb.length>0">

                <div class='imgArea' v-if="dynamiclistdata.msg_type==1">

                  <div class="block01" v-if="dynamiclistdata.thumb.length==1">

                    <div v-if="dynamiclistdata.is_long==1">

                      <div v-for="(item,index) in dynamiclistdata.thumb" :key="index" v-if="index<9">
                        <img :src="item" class="longpic" @click.stop="onChange" />

                        <van-image-preview v-model="show" :images="dynamiclistdata.extra" @change="onChange">
                          <template v-slot:index>第{{ index }}页</template>
                        </van-image-preview>

                      </div>

                    </div>

                    <div v-else>
                      <div v-for="(item,index) in dynamiclistdata.thumb" :key="index" v-if="index<9">
                        <img :src="item" class="widthpic" @click.stop="onChange" />
                        <van-image-preview v-model="show" :images="dynamiclistdata.thumb" @change="onChange">
                          <template v-slot:index>第{{ index }}页</template>
                        </van-image-preview>
                      </div>
                    </div>

                  </div>

                  <div v-else class="block02">
                    <div v-for="(item,index) in dynamiclistdata.thumb" :key="index">
                      <!-- <img :src="item" @click="onChange(index)" /> -->
                      <van-image fit="cover" :src="item" @click.stop="onChange(index)" />
                    </div>

                    <van-image-preview v-model="show" :images="dynamiclistdata.extra" @change="onChange" :startPosition="index">
                      <template v-slot:index>第{{index+1}}张</template>
                    </van-image-preview>

                  </div>

                </div>

                <div v-else class="videoshowbox" @click="gotocircledetails(dynamiclistdata.id,dylistindex)">
                  <div v-if="dynamiclistdata.is_long==1">
                    <div class="longvideobox">
                      <img :src="dynamiclistdata.thumb[0]" class="longvideo" />
                      <img class="videoicon" :src="videoicon" />
                    </div>
                  </div>
                  <div v-else>
                    <div class="normalvideobox">
                      <img :src="dynamiclistdata.thumb[0]" class="normalvideo" />
                      <img class="videoicon" :src="videoicon" />
                    </div>
                  </div>
                </div>

              </div>

            </div>

            <!--转发的内容-->
            <div class="forward-content" v-else>
              <div class="forward-content-nrbox" @click.stop="gotocircledetails(dynamiclistdata.id,dylistindex)">
                <div :class="dynamiclistdata.is_exceed % 2 == 0 ? 'bigheight':'article-content-text' " ref="circlecontent">
                  <p style="padding-right:0.2702702702702703rem;"><span class="content-text02 cuIcon-pic" v-if="dynamiclistdata.extra.length != 0" @click.stop="onChange2">
                      <van-icon size="0.95rem" name="photo-o" style="float:left;padding-top:0.12rem; margin-right:0.2rem;" /><i style="font-style: normal;">查看图片</i></span>
                    <pre>{{dynamiclistdata.content}}</pre>

                    <van-image-preview v-model="show2" :images="dynamiclistdata.extra" @change="onChange2">
                    </van-image-preview>
                  </p>
                </div>

                <div class="article-content-btn" v-if="dynamiclist.is_exceed!=0" @click.stop="openbtn(dylistindex)">
                  <p v-if="dynamiclist.is_exceed % 2 == 1">展开</p>
                  <p v-else>收起</p>
                </div>

              </div>

              <div class="forward-othercontent" v-if="dynamiclistdata.pid_info.is_del==0" @click.stop="gotocircledetails(dynamiclistdata.pid_info.id,dylistindex)">

                <div class="f-o-topbox">
                  <div class="f-o-toptx">
                    <img :src="dynamiclistdata.pid_info.avatar_url" />
                  </div>
                  <div class="f-o-topname">{{dynamiclistdata.pid_info.name}}</div>
                </div>

                <pre class="f-o-commentbox">{{dynamiclistdata.pid_info.content}}</pre>
                <div class="morediv" v-if="dynamiclistdata.pid_info.is_exceed==1">
                  <p>更多</p>
                </div>

                <div class="f-o-imgbox">

                  <div class='imgAreabox' v-if="dynamiclistdata.pid_info.msg_type==1">
                    <!-- wx:if="{{!item.imgArea}}" -->

                    <div class="block01" v-if="dynamiclistdata.pid_info.thumb.length==1">

                      <div v-if="dynamiclistdata.pid_info.is_long==1">

                        <div v-for="(item,index) in dynamiclistdata.pid_info.thumb" :key="index" v-if="index<9">
                          <img :src="item" class="longpic" @click.stop="onChange" />

                          <van-image-preview v-model="show" :images="dynamiclistdata.pid_info.extra" @change="onChange">
                            <template v-slot:index>第{{ index }}页</template>
                          </van-image-preview>

                        </div>

                      </div>

                      <div v-else>
                        <div v-for="(item,index) in dynamiclistdata.pid_info.thumb" :key="index" v-if="index<9">
                          <img :src="item" class="widthpic" @click.stop="onChange" />
                          <van-image-preview v-model="show" :images="dynamiclistdata.pid_info.extra" @change="onChange">
                            <template v-slot:index>第{{ index }}页</template>
                          </van-image-preview>
                        </div>
                      </div>

                    </div>

                    <div class="block02" v-if="dynamiclistdata.pid_info.thumb.length>1">

                      <div v-for="(item,index) in dynamiclistdata.pid_info.thumb" :key="index">
                        <!-- <img :src="item" @click="onChange(index)" /> -->
                        <van-image fit="cover" :src="item" @click.stop="onChange(index)" />
                      </div>
                      <van-image-preview v-model="show" :images="dynamiclistdata.pid_info.extra" @change="onChange" :startPosition="index">
                        <template v-slot:index>第{{index+1}}张</template>
                      </van-image-preview>

                    </div>
                  </div>

                  <div v-else class="videoshowbox" @click="gotocircledetails(dynamiclistdata.pid_info.id,dylistindex)">
                    <div v-if="dynamiclistdata.pid_info.is_long==1">
                      <div class="longvideobox">
                        <img :src="dynamiclistdata.pid_info.thumb[0]" class="longvideo" />
                        <img class="videoicon" :src="videoicon" />
                      </div>
                    </div>
                    <div v-else>
                      <div class="normalvideobox">
                        <img :src="dynamiclistdata.pid_info.thumb[0]" class="normalvideo" />
                        <img class="videoicon" :src="videoicon" />
                      </div>
                    </div>
                  </div>

                </div>
                <div class="forward_info">{{dynamiclistdata.pid_info.forward_num}}转发 · {{dynamiclistdata.pid_info.comment_num}}评论 · {{dynamiclistdata.pid_info.nices_num}}鼓掌</div>
              </div>

              <div class="forward-othercontent" v-else>
                <div class="f-o-topbox">
                  <div class="f-o-toptx">
                    <img :src="dynamiclistdata.pid_info.avatar_url" />
                  </div>
                  <div class="f-o-topname">
                    {{dynamiclistdata.pid_info.name}}
                  </div>
                </div>
                <div class="f-o-commentbox deltext">
                  {{dynamiclistdata.pid_info.content}}
                </div>
              </div>

            </div>

            <div class="article-echo">
              <!-- <div class="xianxian"></div> -->
              <div class="article-echo-cell article-echo-forward" @click.stop="gotoforward(dynamiclistdata.id,dynamiclistdata.is_own)">
                <img src="../../assets/images/dynamic_icon_forwarding.png" />
                <span v-if="dynamiclistdata.forward_num==0">转发</span>
                <span v-else>{{dynamiclistdata.forward_num}}</span>
              </div>
              <div class="article-echo-cell article-echo-comment" @click.stop="gotocircledetails(dynamiclistdata.id,dylistindex)">
                <img src="../../assets/images/dynamic_icon_comment.png" />
                <span v-if="dynamiclistdata.comment_num==0">评论</span>
                <span v-else>{{dynamiclistdata.comment_num}}</span>
              </div>
              <div class="article-echo-cell article-echo-applause" @click.stop="applausebtn(dynamiclistdata.id)">
                <div v-if="dynamiclistdata.is_nice == 1">
                  <img src="../../assets/images/dynamic_btn_applause_selected.png" />
                  <span class="red">{{dynamiclistdata.nices_num}}</span>
                </div>
                <div v-else>
                  <img src="../../assets/images/dynamic_btn_applause_normal.png" />
                  <span v-if="dynamiclistdata.nices_num == 0">鼓掌</span>
                  <span v-else class="textnum">{{dynamiclistdata.nices_num}}</span>
                </div>
              </div>
              <div class="article-echo-cell article-echo-applause">
                <img src="../../assets/images/dynamic_icon_share_a.png" />
                <button @click.stop="showDynamicPopup(dylistindex)" v-clipboard:copy="config.link">分享</button>
              </div>
            </div>

          </div>
        </div>

      </div>

      <van-popup v-model="showpopup" position="bottom" :style="{ height: '19%' }">
        <dl class="cleardl">
          <dt v-if="dynamiclistdata.is_own==1" @click="clearmydynamic(dynamiclistdata.id)">删除</dt>
          <dt v-else @click="jubao(dynamiclistdata.id)">举报</dt>
          <dd @click="hidePopup">取消</dd>
        </dl>
      </van-popup>

      <!--动态详情--分享到-->
      <van-popup v-model="showDPopup" position="bottom" :style="{ height: '50%' }">
        <div class="sharedownbox">
          <vue-native-share :shareMenu="shareMenu" :config="config" :fzljLink="fzljLink" />
        </div>
        <van-button class="sharetopbox" @click="hidePopup" type="default" block>取消分享</van-button>
      </van-popup>
    </van-skeleton>
  </div>
</template>

<script>
import Vue from "vue";
import Bus from "@/assets/js/bus.js";
import { ImagePreview } from "vant";
import { Dialog } from "vant";
import { Toast } from "vant";
import { clearmydynamic, gettonicemsg, getmines } from "../../api/api";
import vueNativeShare from "../plugins/vue-native-share";
import Axios from "axios";
import { mapState } from 'vuex';
Vue.use(ImagePreview);
export default {
  props: [
    "dynamiclistdata",
    "dylistindex",
    "allnamiclistdata",
    "alldynamiccnum"
  ],
  name: "circledylist",
  components: {
    vueNativeShare
  },
  data () {
    return {
      imgArr: [],
      applausenum: 0,
      //applauseicon:`${app.globalData.baseImgUrl}/xianpipa/images/dynamic_btn_applause_normal.png`,
      //applauseicon02:`${app.globalData.baseImgUrl}/xianpipa/images/dynamic_btn_applause_selected.png`,
      currentSize: 0,
      words: [],
      dynamiccontent: {},
      dynamiclist: this.dynamiclistdata, //动态列表
      page: 0, //从第一页
      pageCount: null, //总页数
      nices_num: 0,
      showactive: 0,
      scrolltop: "",
      otherrenid: "", //查看其他人的动态
      circleid: "",
      msgtype: 0, //默认分类
      nodynamic: false,
      ondynamicid: "", //当前动态的ID
      listindex: "", //动态遍历的序号
      downshow: false,
      showtopshowbox: false,
      //isIphoneX: app.globalData.isIphoneX,  //显示头部
      is_own: "",
      show: false,
      show2: false,
      loading: true,
      index: 0,
      startPosition: 0,
      imagesthumb: this.dynamiclistdata.thumb,
      showpopup: false,
      videoicon: require("../../assets/images/find_icon_play.png"),
      avatar_url: require("../../assets/images/moren.jpg"),
      config: {
        title: "鲜枇杷名片-动态详情",
        desc: "免费为企业/个人制作电子名片，扫描二维码生成你的专属电子名片",
        img: "https://api.xianpipa.com/xianpipa/images/logo.png",
        img_title: "一款名片应用",
        link: "",
        success: () => {
          console.log("success");
        },
        cancel: () => {
          console.log("cancel");
        }
      },
      showDPopup: false,
      shareMenu: [0, 1, 2, 3],
      fzljLink: ''
    };
  },
  computed: {
    ...mapState(["baseAPI"]),
    ...mapState(["baseURL"])
  },
  mounted () {
    let that = this;
    setTimeout(function () {
      that.loading = false;
    }, 500);
  },
  methods: {
    onChange (index) {
      this.index = index;
      this.show = true;
      this.startPosition = index + 1;
    },

    onChange2 () {
      this.show2 = true;
    },

    gotootherdynamic (e) {

      let otherrenid = e;

      this.$router.push({
        name: 'dynamic',
        query: {
          otherrenid: otherrenid
        }
      })

    },
    showDynamicPopup (i) {
      this.fzljLink = this.allnamiclistdata[i].shareUrl
      this.config.link = this.baseURL + '/#/dynamicdetails?id=' + this.allnamiclistdata[i].id;
      if (/micromessenger/i.test(navigator.userAgent)) {
        //微信复制链接
        Toast.success({
          duration: 2000,
          message: "链接已复制，快去分享吧！"
        });
      } else {
        this.showDPopup = true;
      }
    },
    showPopup () {
      this.showpopup = true;
    },
    hidePopup () {
      this.showpopup = false;
      this.showDPopup = false;
    },
    gotocircledetails (id, index) {
      this.$router.push({
        name: "dynamicdetails",
        query: {
          index: index,
          id: id
        }
      });
    },

    //删除动态
    clearmydynamic (e) {
      let that = this;
      let ondynamicid = e;
      let listindex = this.dylistindex;
      const baseURL = this.baseAPI;
      Dialog.confirm({
        title: "提示",
        message: "确定删除动态"
      })
        .then(() => {
          cleardy();
        })
        .catch(() => {
          // on cancel
          that.showpopup = false;
        });

      function cleardy () {
        let AUTH_TOKEN = localStorage.getItem("token");
        Axios.defaults.headers.common["Authorization"] = "Bearer " + AUTH_TOKEN;
        Axios.defaults.headers.common["PLATFORM"] = "H5";
        //Axios.defaults.baseURL = baseURL;

        Axios.delete(baseURL + "/v1/messages/" + ondynamicid).then(res => {

          if (res.data.code == 200) {
            let allnamiclistdata = that.allnamiclistdata;

            allnamiclistdata.splice(listindex, 1);

            let alldynamiccnum = that.alldynamiccnum - 1;

            Bus.$emit("alldynamiccnum", alldynamiccnum);

            Toast.success("成功删除");

            that.hidePopup();
          } else {
            Toast.fail("删除失败");
          }
        });
      }
    },
    jubao (e) {
      let that = this;
      let ondynamicid = e;
      Dialog.confirm({
        title: "提示",
        message: "是否举报该信息"
      })
        .then(() => {
          jubaody();
        })
        .catch(() => {
          // on cancel
          that.showpopup = false;
        });

      function jubaody () {
        that.$router.push({
          name: "report",
          query: {
            id: ondynamicid
          }
        });
      }
    },
    //鼓掌
    applausebtn (e) {
      var item_id = e; //此处找到列表的id
      this.guzhang(item_id);
    },

    //鼓掌功能
    guzhang: function (item_id) {
      var that = this;
      var show; //传递到数据库点赞的状态

      if (localStorage.getItem("guzhangshu")) {
        var cookie_mid = localStorage.getItem("guzhangshu").split(",");
      } else {
        var cookie_mid = [];
      }

      var newmessage = [];

      if (that.dynamiclistdata.id == item_id) {

        var num = that.dynamiclistdata.nices_num; //当前赞数
        var isnice = that.dynamiclistdata.is_nice;
        var isshow; //点赞的状态

        if (cookie_mid.includes(item_id) || isnice == 1) {
          //说明已经点过赞,取消赞
          for (var j = 0; j < cookie_mid.length; j++) {
            if (cookie_mid[j] == item_id) {
              cookie_mid.splice(j, 1); //删除取消赞的mid
            }
          }
          --num;
          if (num < 0) {
            num == 0;
          }
          isshow = 0; //点赞的状态
          that.dynamiclistdata.nices_num = num;
          that.dynamiclistdata.is_nice = isshow;
          localStorage.setItem("guzhangshu", cookie_mid.toString());
        } else {
          isshow = 1; //点赞的状态
          ++num;
          that.dynamiclistdata.nices_num = num;
          that.dynamiclistdata.is_nice = isshow;
          cookie_mid.unshift(item_id);
          localStorage.setItem("guzhangshu", cookie_mid.toString());
        }

        gettonicemsg(item_id).then(res => {
        });
      }

    },

    //转发功能
    gotoforward (msg_id, is_own) {
      this.$router.push({
        path: "/forward",
        query: {
          isdynamic: true,
          is_own: is_own,
          msg_id: msg_id
        }
      });


    },

    gotocirclecontent (e) {
      let circleid = e;

      this.circleid = circleid;

      this.$router.push({
        path: "/circlecontent",
        query: {
          id: circleid
        }
      });
    },

    openbtn (e) {
      let listindex = e;
      var num = this.dynamiclist.is_exceed; //当前赞数
      ++num;
      this.dynamiclist.is_exceed = num; //es6模板语法（反撇号字符）
    }
  }
};
</script>

<style scoped>
.forward-templateall {
}
.forward-templateall .articlebox {
  flex-flow: row nowrap;
  border-bottom: 0.40540540540540543rem solid #f8f8f8;
  background: #fff;
  /* padding-bottom: 0.8108108108108109rem;
     */
}
.forward-templateall .articlebox .articleleft {
  width: 3.135135135135135rem;
}

.forward-templateall .articlebox .articleright .articletx {
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
  margin-right: 0.5405405405405406rem;
  margin-left: 0.3rem;
}
.forward-templateall .articlebox .articleright .articletx img {
  width: 1.7837837837837838rem;
  height: 1.7837837837837838rem;
  border-radius: 50%;
  border: 1px solid #f2f2f2;
}
.forward-templateall .articlebox .articleright {
  margin: 0 0.3rem;
}
.forward-templateall .articlebox .articleright .article-r-top {
  padding-top: 0.8108108108108109rem;
}
.forward-templateall .articlebox .articleright .article-r-top .article-title {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-author {
  font-size: 0.7567567567567568rem;
  color: #333;
  font-weight: bold;
}

.forward-templateall .articlebox .articleright .article-r-top .followbtn {
  float: right;
  /* padding-top:0.40540540540540543rem;
     padding-right: 0.8108108108108109rem;
     */
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .followbtn
  button {
  width: 3.7567567567567566rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #ffbd0a;
  line-height: 1.3513513513513513rem;
  color: #ffbd0a;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .followbtn
  .active {
  width: 3.7567567567567566rem;
  font-size: 0.7027027027027027rem;
  height: 1.4324324324324325rem;
  background: #fff;
  border: 1px solid #999;
  line-height: 1.3513513513513513rem;
  color: #999;
}
.forward-templateall .articlebox .articleright .article-r-top .cleardynamic {
  float: right;
  padding-top: 0.13513513513513514rem;
  padding-right: 0.4864864864864865rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .cleardynamic
  span {
  color: #999;
  font-size: 1.5rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-r-top
  .article-title
  .article-time {
  padding-top: 0.2702702702702703rem;
  font-size: 0.7567567567567568rem;
  color: #999;
}

.forward-templateall .articlebox .articleright .article-content {
  /* padding-top: 0.40540540540540543rem;
     */
  position: relative;
  /* padding-right: 0.6756756756756757rem;
     */
  padding: 0.4rem 0.27rem 0 0.27rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-text {
  color: #333;
  font-size: 0.75rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
  line-height: 1.0810810810810811rem;
  overflow: hidden;
  max-height: 6.486486486486487rem;
}
.forward-templateall .articlebox .articleright .article-content .bigheight {
  color: #333;
  font-size: 0.7567567567567568rem;
  white-space: wrap;
  text-overflow: ellipsis;
  line-height: 1.0810810810810811rem;
  overflow: auto;
  max-height: auto;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-btn {
  padding-top: 0.40540540540540543rem;
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .article-content
  .article-content-btn
  p {
  font-size: 0.75rem;
}
.forward-templateall .articlebox .articleright .article-imagebox {
  margin-top: 0.8108108108108109rem;
  background: #fff;
  margin-bottom: 0.40540540540540543rem;
  padding: 0 0.2702702702702703rem;
}

.forward-templateall .articlebox .articleright .article-imagebox .imgArea {
}

.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02 {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02
  .van-image {
  width: 6rem;
  height: 6rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block02
  img {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 6rem;
  height: 6rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01 {
  display: flex;
  flex-flow: row wrap;
  align-items: flex-start;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01
  img.widthpic {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  max-width: 12.432432432432432rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .imgArea
  .block01
  img.longpic {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 12.432432432432432rem;
  max-height: 16.486486486486488rem;
  margin: 0 0.13513513513513514rem;
}

.forward-templateall .articlebox .articleright .article-imagebox .videoshowbox {
  /*   padding-right: 25rpx; */
  position: relative;
}
.forward-templateall .articlebox .articleright .article-imagebox .videocover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 5;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  video {
  width: 100%;
  height: 10.675675675675675rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  video.longvideo {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .normalvideobox {
  width: 100%;
  height: 10.675675675675675rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .normalvideobox
  .normalvideo {
  width: 100%;
  height: 10.675675675675675rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .longvideobox {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .article-imagebox
  .videoshowbox
  .longvideobox
  .longvideo {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-echo
  .article-echo-cell
  span.red {
  color: #f00;
}
.forward-templateall .articlebox .articleright .article-echo {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  justify-items: center;
  padding: 0.5405405405405406rem 0;
  margin: 0.5405405405405406rem 0.5405405405405406rem 0 0.5405405405405406rem;
  border-top: 1px solid #e5e5e5;
}
.forward-templateall .articlebox .articleright .article-echo div {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.forward-templateall .articlebox .articleright .article-echo div img {
  width: 1.027027027027027rem;
  height: 1.0810810810810811rem;
  margin-right: 0.40540540540540543rem;
}
.forward-templateall .articlebox .articleright .article-echo div span {
  font-size: 0.7567567567567568rem;
  color: #333;
}
.forward-templateall .articlebox .articleright .article-echo div button {
  font-size: 0.7567567567567568rem;
  color: #333;
  border: 0;
  background: #fff;
}
.forward-templateall .articlebox .articleright .article-videobox video {
  display: inline-block;
  max-width: 100%;
  height: auto;
  min-width: 70%;
}

.forward-templateall .articlebox .articleright .article-circlefollow {
  min-width: 6.756756756756757rem;
  height: 1.6216216216216217rem;
  background: #ffbd0a;
  border-radius: 0.2702702702702703rem;
  overflow: hidden;
  margin-top: 0.6756756756756757rem;
  margin-left: 0.21621621621621623rem;
  display: inline-block;
}
.forward-templateall .articlebox .articleright .article-circlefollow img {
  width: 0.9rem;

  float: left;
  margin-top: 0.3783783783783784rem;
  margin-left: 0.5405405405405406rem;
}
.forward-templateall .articlebox .articleright .article-circlefollow span {
  color: #fff;
  float: left;
  margin-left: 0.40540540540540543rem;
  padding-right: 0.2702702702702703rem;
  padding-top: 0.32432432432432434rem;
  font-size: 0.72rem;
}
.forward-templateall
  .articlebox
  .articleright
  .article-circlefollow
  .righticon {
  float: right;
  font-size: 0.5405405405405406rem;
  padding-right: 0.2702702702702703rem;
  padding-top: 0.5rem;
}

.forward-templateall .articlebox .articleright .forward-content {
  clear: both;
  overflow: hidden;
  padding: 0.40540540540540543rem 0.2702702702702703rem 0 0.2702702702702703rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox {
  font-size: 0.7567567567567568rem;
  line-height: 1.2432432432432432rem;
  padding-bottom: 0.5405405405405406rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .article-content-btn {
  padding-top: 0.40540540540540543rem;
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .article-content-text {
  color: #333;
  font-size: 0.7567567567567568rem;
  line-height: 1.0810810810810811rem;
  overflow: hidden;
  max-height: 6.486486486486487rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  /* 可以显示的行数，超出部分用...表示*/
  -webkit-box-orient: vertical;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .bigheight {
  color: #333;
  font-size: 0.7567567567567568rem;
  line-height: 1.0810810810810811rem;
  overflow: auto;
  max-height: auto;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  img.content-img {
  margin-left: 0.2702702702702703rem;
  width: 0.8648648648648649rem;
  margin-bottom: -0.08108108108108109rem;
  height: 0.7297297297297297rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .content-text02 {
  color: #6699ff;
  font-size: 0.7027027027027027rem;
  white-space: nowrap;
  padding-right: 0.40540540540540543rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-content-nrbox
  .cuIcon-pic {
  font-size: 0.7297297297297297rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent {
  background: #f6f6f6;
  padding: 0.5rem;
  /* margin-bottom: 0.5405405405405406rem;
     */

  border-radius: 0.2702702702702703rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox {
  overflow: hidden;
  clear: both;
  padding-right: 0.5405405405405406rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-toptx {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  float: left;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-toptx
  img {
  width: 1.3513513513513513rem;
  height: 1.3513513513513513rem;
  border-radius: 50%;
  border: 1px solid #f2f2f2;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-topbox
  .f-o-topname {
  float: left;
  padding-top: 0.21621621621621623rem;
  padding-left: 0.5405405405405406rem;
  font-size: 0.7567567567567568rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-commentbox {
  /* padding-top: 0.5405405405405406rem;
     */
  max-height: 7.027027027027027rem;
  overflow: hidden;
  line-height: 1.0810810810810811rem;
  padding: 0.5405405405405406rem 0.2702702702702703rem 0 0.2702702702702703rem;
  /* padding-right:0.2702702702702703rem;
     */
  font-size: 0.75rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .deltext {
  color: #999;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .moreview {
  padding-top: 0.40540540540540543rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .moreview
  text {
  color: #6699ff;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-infobox {
  padding-top: 0.5405405405405406rem;
  color: #999;
  padding: 0 0.2702702702702703rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox {
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01
  img.widthpic {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 12.432432432432432rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01
  img.longpic {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 12.432432432432432rem;
  max-height: 16.486486486486488rem;
  margin: 0 0.13513513513513514rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02 {
  margin-top: 0.5405405405405406rem;
  display: flex;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-items: flex-start;
  padding: 0.25rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02
  .van-image {
  width: 5.45945945945946rem;
  height: 5.45945945945946rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block02
  img {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 5.45945945945946rem;
  height: 5.45945945945946rem;
  margin: 0 0.13513513513513514rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01 {
  margin-top: 0.5405405405405406rem;
  display: flex;
  flex-wrap: wrap;
  flex-flow: row wrap;
  align-items: flex-start;
  padding: 0.2702702702702703rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .imgAreabox
  .block01
  img {
  /* width: 5.135135135135135rem;
     height:5.135135135135135rem;
     margin: 0 0.40540540540540543rem 0.1891891891891892rem 0;
     */
  width: 12.432432432432432rem;
  margin: 0 0.13513513513513514rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videoshowbox {
  padding-top: 0.5405405405405406rem;
  padding-left: 0.2702702702702703rem;
  position: relative;
  /* padding-right: 0.5405405405405406rem;
     */
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videocover {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 5;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .normalvideobox {
  width: 100%;
  height: 10.675675675675675rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .normalvideobox
  .normalvideo {
  width: 100%;
  height: 10.675675675675675rem;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .longvideobox {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
  position: relative;
}
.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .longvideobox
  .longvideo {
  width: 12.162162162162161rem;
  height: 16.216216216216218rem;
}

.forward-templateall
  .articlebox
  .articleright
  .forward-content
  .forward-othercontent
  .f-o-imgbox
  .videoshowbox
  video {
  width: 100%;
  height: 8.108108108108109rem;
}
.forward_info {
  color: #999;
  font-size: 0.6486486486486487rem;
  margin: 0.2702702702702703rem 0;
  margin-left: 0.2rem;
}
.videoicon {
  width: 2.7027027027027026rem;
  height: 2.7027027027027026rem;
  position: absolute;
  top: 50%;
  right: 50%;
  margin-top: -1.3513513513513513rem;
  margin-right: -1.3513513513513513rem;
}

.cleardl {
}
.cleardl dt {
  text-align: center;
  border-bottom: 5px solid #f8f8f8;
  padding-top: 0.9rem;
  padding-bottom: 0.9rem;
  font-size: 0.7567567567567568rem;
}
.cleardl dd {
  text-align: center;
  padding-top: 0.9rem;
  font-size: 0.7567567567567568rem;
}
.sharetopbox {
  position: absolute;
  bottom: 0;
}
pre {
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  word-break: break-all;
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/public/circledylist.vue